import { useApiService, useRouter, useTl } from "..";
import {
  useAuth,
  useBreadcrumbData,
  useDialog,
  useEventsContext,
  useGlobalData,
  useNavigationContext,
} from "../../contexts";
import { useValidators } from "./useValidators";
import {
  ActionRoleApi,
  AgentApi,
  AgentFunctionApi,
  AssessementDossierApi,
  CancellationReasonApi,
  DataTranslationApi,
  DossierDocumentApi,
  DossierTasksApi,
  EvaluationInterviewApi,
  FormQuestionApi,
  FormQuestionOperationalApi,
  FunctionalDirectorApi,
  FunctionApi,
  GradeFunctionApi,
  JobInterviewApi,
  JobInterviewDateApi,
  MentionApi,
  ObjectiveQuestionApi,
  OperationalInterviewApi,
  OperationalInterviewDateApi,
  ReferentialApi,
  SearchCriteriaApi,
  SubstitutionApi,
  SystemApi,
  TranslationApi,
  TranslationCodeApi,
  UserApi,
} from "../../api";
import { getEnvironmentTheme, getTheme, SiteEnvironment } from "../../theme";
import { useManageValidationErrors } from "../useManageValidationErrors";
import React from "react";

export function useCommonHooks() {
  const environment = useGlobalData().systemInfo?.environment;
  const actionRoles = useApiService(ActionRoleApi);
  const system = useApiService(SystemApi);
  const dataTranslations = useApiService(DataTranslationApi);
  const referentials = useApiService(ReferentialApi);
  const translationCodes = useApiService(TranslationCodeApi);
  const translations = useApiService(TranslationApi);
  const user = useApiService(UserApi);
  const searchCrterias = useApiService(SearchCriteriaApi);
  const agents = useApiService(AgentApi);
  const agentFunctions = useApiService(AgentFunctionApi);
  const gradeFunctions = useApiService(GradeFunctionApi);
  const dossiers = useApiService(AssessementDossierApi);
  const jobInterviewDates = useApiService(JobInterviewDateApi);
  const operationalInterviewDates = useApiService(OperationalInterviewDateApi);
  const mentions = useApiService(MentionApi);
  const formQuestions = useApiService(FormQuestionApi);
  const jobInterviews = useApiService(JobInterviewApi);
  const formQuestionOperationals = useApiService(FormQuestionOperationalApi);
  const OperationalInterview = useApiService(OperationalInterviewApi);
  const dossierTasks = useApiService(DossierTasksApi);
  const functions = useApiService(FunctionApi);
  const functionalDirectors = useApiService(FunctionalDirectorApi);
  const substitutions = useApiService(SubstitutionApi);
  const objectiveQuestions = useApiService(ObjectiveQuestionApi);
  const dossierDocuments = useApiService(DossierDocumentApi);
  const evaluationInterviews = useApiService(EvaluationInterviewApi);
  const cancellationReasons = useApiService(CancellationReasonApi);

  const apis = React.useMemo(
    () => ({
      actionRoles,
      dataTranslations,
      referentials,
      translationCodes,
      translations,
      user,
      searchCrterias,
      system,
      agents,
      agentFunctions,
      gradeFunctions,
      dossiers,
      jobInterviewDates,
      operationalInterviewDates,
      mentions,
      formQuestions,
      jobInterviews,
      formQuestionOperationals,
      OperationalInterview,
      dossierTasks,
      functions,
      functionalDirectors,
      substitutions,
      objectiveQuestions,
      dossierDocuments,
      evaluationInterviews,
      cancellationReasons
    }),
    [actionRoles, dataTranslations, referentials, translationCodes, translations, user, searchCrterias, system, agents, agentFunctions, gradeFunctions, dossiers, jobInterviewDates, operationalInterviewDates, mentions, formQuestions, jobInterviews, formQuestionOperationals, OperationalInterview, dossierTasks, functions, functionalDirectors, substitutions, objectiveQuestions, dossierDocuments, evaluationInterviews, cancellationReasons]
  );
  return {
    ...useTl(),
    router: useRouter(),
    ...useBreadcrumbData(),
    ...useAuth(),
    ...useGlobalData(),
    ...useEventsContext(),
    ...useNavigationContext(),
    ...useDialog(),
    ...useManageValidationErrors(),
    validators: useValidators(),
    theme: getTheme("base"),
    environmentTheme: getEnvironmentTheme(environment as SiteEnvironment),
    apis,
  };
}
